import tool from 'src/utils/tool';
import { INVENTORY_FLOW } from 'src/const/state/inventory-type';
import { isBOE } from 'src/const/boe';
import { BidRegion } from 'src/const/state/bid-region';
import { isIndia, isSg, IMAGE_X_IMG_TEMPLATE } from 'src/const/gcp';
import { campaignObjectiveValue } from 'src/const/state/campaign';
import API from 'src/const/apis';
import { i18n } from 'src/utils/localeUtil';
import customizedImageCardPoster from 'src/assets/images/additional-customized-image-card-demo-video-poster.png';
import eggDemoImg from 'src/assets/images/fudai.png';
import gestureDemoImg from 'src/assets/images/gesture.png';
import _ from 'lodash';

export * from '../creative/identity';


const { getReverseMap, isSupportWebp } = tool;

// 针对内部广告主如果创编的campaign/create｜ad/create｜creative/create接口任意一个出现list中的错误code，不执行三秒后跳转，以及取消广告创建的弹窗。
// 40102 Permission error 没有写权限，一般是使用附身真实广告主的场景。
export const noCreateSuccessDialogCodeList = [40102];

export const LeadBCShare = {
  NONESHARE: 0,
  ISSHARED: 1,
};

export const estimateScoreMap = {
  DEFAULT: '0',
  NAEEOW: '1', // 过窄
};

// aco开白后最大上传素材数
export const acoUnLockListMaxNum = 30;
// aco没开白最大上传素材数
export const acoLockListMaxNum = 10;

export const MATERIAL_TYPE_ENUM = {
  VIDEO: 1,
  IMAGE: 2,
  TEXT: 3,
  OTHER: 9,
};

// 静态资源前缀特殊环境配置项
const specialImgPrefixConfig = [
  { value: isBOE, data: process.env.BOE_IMG_SRC_PREFIX },
  { value: isIndia, data: process.env.GCP_IMG_SRC_PREFIX },
  { value: isSg, data: process.env.SG_IMG_SRC_PREFIX },
];
// 迁环境的时候帮我改一下！！！
// 这是附加创意图片获取的URI 前缀，创意那边只有线上的图片存储，所以我们只能强制拼线上前缀，无法区分环境
export const additionalCreativeImagePrefix = process.env.SG_IMG_SRC_PREFIX;

// 预校验根据后端返回的key拼接提示的map
export const realTimePrecheckSplicingMap = {
  // language_mismatch模型
  material_language_mismatch: {
    ownKey: 'material_language_mismatch',
    countryHitCode: '21100141',
    occupy: '{targeting_country}',
    replaceKey: 'module_text_real_check_fail_target_country_tips',
    // dialogReplaceKey: 'module_text_real_check_fail_target_country_dialog',
    link: {
      key: 'module_text_real_check_fail_target_country_tips_learn_more',
      url: 'https://ads.tiktok.com/help/article?aid=9552',
    },
  },
};
// 获取序号为index广告下的countryHit
export const getSingleCountriesHitList = (realTimePrecheckSuggtions, index) => {
  try {
    const countryhitList = _.get(realTimePrecheckSuggtions,
      `[${index}].ads_texts.ads_texts[0].details.${realTimePrecheckSplicingMap.material_language_mismatch.countryHitCode}`, '');
    return Object.values(JSON.parse(countryhitList).hit_countries);
  } catch (e) {
    return [];
  }
};
// commonDealSuggtion 对suggtion做过滤处理
export const getSuggtion = function (item, index, realTimePrecheckSuggtions) {
  if (realTimePrecheckSplicingMap[item]) {
    return this.$t(realTimePrecheckSplicingMap[item].replaceKey).replace(realTimePrecheckSplicingMap.material_language_mismatch.occupy,
      getSingleCountriesHitList(realTimePrecheckSuggtions, index)?.toString());
  }
  return item;
};
// suggtion后的链接是否展示
export const dealShowSuggtionLink = (item) => {
  if (realTimePrecheckSplicingMap[item]) {
    return realTimePrecheckSplicingMap[item].link;
  }
  return false;
};


// 静态资源前缀
export const imgSrcPrefix = (() => {
  const suitableConfig = specialImgPrefixConfig.find(v => v.value);
  if (suitableConfig) {
    return suitableConfig.data || process.env.SG_IMG_SRC_PREFIX;
  }
  return process.env.SG_IMG_SRC_PREFIX;
})();

// 目前素材库支持排序的api
export const supportSortAjaxUrl = [
  API.ad.image_material_list,
  API.ad.video_material_list,
];

// 素材库排序数组
export const creativeLibSortList = [
  { value: 1, label: 'module_library_sort_by_creation_time_new_to_old', sortData: { sort_order: 1, sort_type: 1 } },
  { value: 2, label: 'module_library_sort_by_creation_time_old_to_new', sortData: { sort_order: 0, sort_type: 1 } },
  // { value: 3, label: 'module_library_sort_by_cost_low_to_high', sortData: { sort_order: 0, sort_type: 2 } },
  { value: 4, label: 'module_library_sort_by_cost_high_to_low', sortData: { sort_order: 1, sort_type: 2 } },
  // { value: 5, label: 'module_library_sort_by_impression_low_to_high', sortData: { sort_order: 0, sort_type: 3 } },
  { value: 6, label: 'module_library_sort_by_impression_high_to_low', sortData: { sort_order: 1, sort_type: 3 } },
  // { value: 7, label: 'module_library_sort_by_click_low_to_high', sortData: { sort_order: 0, sort_type: 4 } },
  { value: 8, label: 'module_library_sort_by_click_high_to_low', sortData: { sort_order: 1, sort_type: 4 } },
  // { value: 9, label: 'module_library_sort_by_conversion_low_to_high', sortData: { sort_order: 0, sort_type: 5 } },
  { value: 10, label: 'module_library_sort_by_conversion_high_to_low', sortData: { sort_order: 1, sort_type: 5 } },
  { value: 11, label: 'module_library_sort_by_cpc_low_to_high', sortData: { sort_order: 0, sort_type: 6 } },
  // { value: 12, label: 'module_library_sort_by_cpc_high_to_low', sortData: { sort_order: 1, sort_type: 6 } },
  { value: 13, label: 'module_library_sort_by_cpa_low_to_high', sortData: { sort_order: 0, sort_type: 7 } },
  // { value: 14, label: 'module_library_sort_by_cpa_high_to_low', sortData: { sort_order: 1, sort_type: 7 } },
  // { value: 15, label: 'module_library_sort_by_ctr_low_to_high', sortData: { sort_order: 0, sort_type: 8 } },
  { value: 16, label: 'module_library_sort_by_ctr_high_to_low', sortData: { sort_order: 1, sort_type: 8 } },
  // { value: 17, label: 'module_library_sort_by_cvr_low_to_high', sortData: { sort_order: 0, sort_type: 9 } },
  { value: 18, label: 'module_library_sort_by_cvr_high_to_low', sortData: { sort_order: 1, sort_type: 9 } },
];


/**
 * 生成ImageX平台图片链接（优化后图片获取方案，支持压缩图片获取）
 * @param {*} imgUri 资源地址
 * @param {*} imgType 图片输出模版，在ImageX配置
 */
export const getImgSrcByImageX = (imgUri = '', imageType = IMAGE_X_IMG_TEMPLATE.COMPRESS_WEBP) => {
  if (!imgUri) {
    return '';
  }

  if (imgUri.search(/^http(s)?:\/\//) > -1) {
    return imgUri;
  }

  // 早期资源数据托管VA机房，单独处理
  if (imgUri.indexOf('/') === -1) {
    return process.env.VA_IMG_SRC_PREFIX.URL + imgUri;
  }

  let imageXTemplate = isBOE ? IMAGE_X_IMG_TEMPLATE.BOE_I18N : imageType;
  // 检查浏览器是否支持webp格式图片
  if (!isSupportWebp()) {
    imageXTemplate = imageXTemplate.replace(/(.webp)$/, '.image');
  }

  return process.env.IMAGE_X_IMG_SRC_PREFIX + imgUri + imageXTemplate;
};

/**
 * 根据环境获取资源地址，主要处理一些老资源托管在VA机房，需要固定使用VA机房的前缀
 * web_uri = 005dd127aea1005745ec 这种类型的，是早期的资源数据，资源托管在VA机房，因此这里需要单独把域名前缀改成VA的
 * web_uri = tos-useast2a-p-0000/xxxxxx 这种的则直接使用当前环境的下资源前缀即可
 * @param {*} imgSrcPrefix 地址前缀对象
 * @param {*} url 资源地址
 */
export const getImgSrcByEnv = (imgSrcPrefix, url = '') => {
  if (url.search(/^http(s)?:\/\//) > -1) {
    return url;
  }

  let avatarUrl = '';
  if (url.indexOf('/') === -1) {
    avatarUrl = process.env.VA_IMG_SRC_PREFIX.URL + url;
  } else {
    avatarUrl = imgSrcPrefix.URL + url;
  }
  return avatarUrl;
};


// 创意生成方式
export const creativeMode = {
  NONE: 0,
  CUSTOMIZE: 2,
  PROCEDURAL: 3,
};
// 创意类型
export const imageMode = {
  NONE: 0,
  // 小图
  IMAGE_I18N_SMALL: 2,
  // 大图
  IMAGE_I18N_LARGE: 3,
  // VIGO 竖图
  IMAGE_I18N_VERTICAL: 16,
  // HELO 竖图
  IMAGE_I18N_SQUARE: 33,
  // pangle使用的720P纵向图片
  IMAGE_I18N_VERTICAL_720P: 173,
  // 组图
  IMAGE_I18N_GROUP: 4,
  // 视频 16:9
  VIDEO_TYPE_1: 5,
  // 视频 1:1
  VIDEO_TYPE_2: 50,
  // 视频 9:16
  VIDEO_TYPE_3: 15,
  // GIF
  GIF_IMAGE: 7,
  // 轮播图
  CAROUSEL_IMAGE: 11,
  // 本地上传
  LOCAL_IMAGE: 100,
  // 搜索图片
  SEARCH_IMAGE: 101,
  // 多图轮播-正方形
  CAROUSEL_IMAGE_SQUARE: 1002,
  // 多图轮播-长方形
  CAROUSEL_IMAGE_HORIZONTAL: 1003,
  // 直投直播间
  REAL_TIME_LIVE: 180,
};
// 多图轮播创意图片版式
export const CAROUSEL_IMAGE_MODE = {
  square: imageMode.CAROUSEL_IMAGE_SQUARE,
  horizontal: imageMode.CAROUSEL_IMAGE_HORIZONTAL,
};
export const getCarouselImageModeMap = () => {
  const map = new Map();
  Object.keys(CAROUSEL_IMAGE_MODE).forEach((key) => {
    map.set(CAROUSEL_IMAGE_MODE[key], key);
  });
  return map;
};

// 根据国家简称批量获取国家Code （辅助函数）
const BatchGetCountriesIdByCountriesSubName = subNameList => subNameList.map((name) => {
  // 转大写
  const SUB_NAME = name.toUpperCase();
  // 找到目标国家
  const targetCountry = BidRegion
    .find(country => country.code === SUB_NAME) || {};
  return targetCountry.id;
})
  .filter(Boolean);

// 根据国家code批量获取国家简称
export const BatchGetCountriesSubNameByCountriesId = countryCodeIdList => countryCodeIdList.map((id) => {
  const targetCountry = BidRegion.find(country => country.id === +id) || {};
  return targetCountry?.code?.toUpperCase();
}).filter(Boolean);


// 允许多图轮播的国家/地区
export const CAROUSEL_IMAGE_CREATIVE_ALLOWED_COUNTRIES = [
  ...BatchGetCountriesIdByCountriesSubName([
    'JP',
  ]),
];

export const CAROUSEL_ENABLE_OBJECTIVE_LIST_V1 = [
  campaignObjectiveValue.AppInstall,
];
export const CAROUSEL_ENABLE_OBJECTIVE_LIST_V2 = [
  campaignObjectiveValue.Traffic,
  campaignObjectiveValue.Conversion,
];

export const advancedCreativeTypeMap = {
  QUESTIONNAIRE_OPTIMIZATION: 43,
  BRAND_LIFT_STUDY: 59,
};
export const ONLY_BLS_ENABLE_CTA_IDS = [
  'brand_lift_study',
];
// CTA规则
export const CTA_RULE = {
  // 仅可用在engagement上的cta
  ONLY_ENGAGEMENT_USEABLE_CTA_LIST: ['view_profile'],
  // 仅RF可用
  ONLY_RF_USEABLE_CTA_LIST: ['join_this_hashtag', 'view_video_with_this_effect', 'shoot_with_this_effect'],
};

// 创意状态选项
export const creativeStatus = {
  NONE: '',
  ENABLE: 'enable',
  DELETE: 'delete',
};


// 端上头像展示的地方是 49dp, 视频播放完蒙版头像是 64dp，
// 为了保证图片不失真，这里把图片分辨率改成 112*3,避免端上图片模糊的问题
export const AVATAR_SIZE = {
  width: 112 * 3,
  height: 112 * 3,
};

export const imageTemplate = {
  // !!CAUTION!!: IMAGE_TYPE_0 是兼容一部分已经生成的 1280 * 720 横图的尺寸和 ratio 的方案，新版中要避免这个值被用到
  IMAGE_TYPE_0: {
    imageMode: imageMode.IMAGE_I18N_LARGE,
    width: 1280,
    height: 720,
    ratio: '1.78',
  },
  HORIZONTAL: {
    imageMode: imageMode.IMAGE_I18N_LARGE,
    width: 1200,
    height: 628,
    ratio: '1.91',
  },
  VERTICAL: {
    imageMode: imageMode.IMAGE_I18N_VERTICAL,
    width: 375,
    height: 604,
    ratio: '0.62',
  },
  VERTICAL_720P: {
    imageMode: imageMode.IMAGE_I18N_VERTICAL_720P,
    width: 720,
    height: 1280,
    ratio: '0.56',
  },
  SQUARE: {
    imageMode: imageMode.IMAGE_I18N_SQUARE,
    width: 640,
    height: 640,
    ratio: '1.00',
  },
  ADDITIONAL_CUSTOMIZED_IMAGE_CARD_HORIZONTAL: {
    width: 750,
    height: 421,
    ration: '1.78',
  },
};
export const CAROUSEL_IMAGE_SIZE_RULE = {
  [imageMode.CAROUSEL_IMAGE_HORIZONTAL]: imageTemplate.HORIZONTAL,
  [imageMode.CAROUSEL_IMAGE_SQUARE]: imageTemplate.SQUARE,
};
export const PixeOnlyTracking = -1; // event tracking 只用来前端交互不落库，表示domain不存在

export const carouselImageInfoTemplate = {
  title: '',
  externalUrl: '',
};
export const CREATIVE_STATUS_MAP = {
  DELIVERY: 'delivery_ok',
  // 一级状态
  // 投放中
  ONE_DELIVERY: 'delivery_ok',
  // 已完成:''
  ONE_DONE: 'time_done',
  // 二级状态
  // 审核中
  TWO_AUDIT_1: 'creative_audit',
  TWO_AUDIT_2: 'creative_reaudit',
  // 拒审
  TWO_OFFLINE_AUDIT_1: 'creative_offline_audit',
  TWO_OFFLINE_AUDIT_2: 'creative_ad_offline_audit',
  // 资产上下线状态
  CREATIVE_ASSET_AUTHORIZATION_LOST: 'creative_asset_authorization_lost',
};
export const carouselImageComponentsRule = {
  conversions: {
    webSite: [
      'title',
      'externalUrl',
    ],
    appDownload: [
      'title',
    ],
  },
  traffic: {
    webSite: [
      'title',
      'externalUrl',
    ],
    appDownload: [
      'title',
    ],
  },
  appInstall: {
    all: [
      'title',
    ],
  },
};
// 创意视频素材信息
export const videoTemplate = {
  VIDEO_TYPE_1: {
    type: 1,
    imageMode: 5,
    label: '16:9',
    width: 960,
    height: 540,
    ratio: '1.78',
    cuttingRange: [1.3889, 2],
    cutType: '1280x720',
  },
  VIDEO_TYPE_2: {
    type: 2,
    imageMode: 50,
    label: '1:1',
    width: 640,
    height: 640,
    ratio: '1.00',
    cuttingRange: [0.7813, 1.3889],
    cutType: '1280x1280',
  },
  VIDEO_TYPE_3: {
    type: 3,
    imageMode: 15,
    label: '9:16',
    width: 540,
    height: 960,
    ratio: '0.56',
    cuttingRange: [0.3437, 0.7813], // 宽高比在[0.3437, 0.7813]都裁剪到0.56
    cutType: 'vertical',
  },
};

// 素材校验错误码常量
export const VERIFY_ERROR_CODE = {
  IMAGE: {
    unsupported: {
      key: 'unsupported', // 版位不支持投放
      value: 1,
    },
    maxSize: {
      key: 'maxSize', // 体积过大
      value: 2,
    },
    resolution: {
      key: 'resolution', // 分辨率不符
      value: 4,
    },
    ratio: {
      key: 'ratio', // 宽高比不符
      value: 8,
    },
  },
  CAROUSEL_IMAGE: {
    unsupported: {
      key: 'unsupported', // 版位不支持投放
      value: 1,
    },
    maxSize: {
      key: 'maxSize', // 体积过大
      value: 2,
    },
    resolution: {
      key: 'resolution', // 分辨率不符
      value: 4,
    },
    ratio: {
      key: 'ratio', // 宽高比不符
      value: 8,
    },
  },
  VIDEO: {
    unsupported: {
      key: 'unsupported', // 版位不支持投放
      value: 1,
    },
    maxSize: {
      key: 'maxSize', // 体积过大
      value: 2,
    },
    ratio: {
      key: 'ratio', // 宽高比不符
      value: 4,
    },
    resolution: {
      key: 'resolution', // 分辨率不符
      value: 8,
    },
    duration: {
      key: 'duration', // 时长不符
      value: 16,
    },
    bitrate: {
      key: 'bitrate', // 比特率/码率不符
      value: 32,
    },
    cuttable: {
      key: 'cuttable', // 无法裁剪
      value: 64,
    },
    invalidCpr: {
      key: 'invalidCpr', // 因版位有该视频所用音乐的版权
      value: 128,
    },
    transcodeFail: {
      key: 'transcodeFail',
      value: 10,
    },
  },
};

// 支持本地解析的视频格式
export const localResolveVideoTypes = ['video/quicktime', 'video/mp4'];

// 文件上传状态
export const fileStatus = {
  LOADING: 'loading',
  READY: 'ready',
  SUCCESS: 'success',
  FAIL: 'fail',
  VFAILED: 'v-failed', // 校验失败
  UPLOADING: 'uploading',
  UNSELECTED: 'unselected',
  CUTTING: 'cutting', // 裁剪中
  DUPLICATE_NAME: 'duplicate_name', // 文件重名
  NAME_LENGTH_INVALID: 'name_length_invalid', // 文件名长度校验不通过(1-100)
  NAME_INCLUDE_EMOJI: 'name_include_emoji', // 文件包含表情
  ANALYSIS_FAILED: 'analysis_failed', // 解析失败
  OVER_SIZE: 'over_size', // 文件超出500M
};

export const videoUploadVerifyMode = {
  afterUpload: 'afterUpload',
  beforeUpload: 'beforeUpload',
};

// 创意类型
export const creativeType = {
  CUSTOM: 2, // 自定义创意
  PROCEDURAL: 3, // 程序化创意
  DPA: 4, // DPA创意
};

// 自定义创意广告类型
export const NORMAL_AD_SOURCES = {
  CREATE_NEW: {
    value: 0, // 手动新建广告塞物料
    i18n: 'adgroup_create_title',
  },
  NATIVE_VIDEO: {
    value: 2, // 原生广告，取达人的物料
    i18n: 'common_native_video_ad',
  },
  TTBA_PUSH_NATIVE_VIDEO: {
    value: 3, // TTBA 推原生视频
    i18n: '',
  },
};
export const getIsNativeAdByAdSource = (adItemSource) => {
  const nativeAdSources = [NORMAL_AD_SOURCES.NATIVE_VIDEO.value, NORMAL_AD_SOURCES.TTBA_PUSH_NATIVE_VIDEO];
  return nativeAdSources.includes(adItemSource);
};

export const NORMAL_AD_SOURCES_REVERSE_MAP = getReverseMap(NORMAL_AD_SOURCES);

// 创意分类
export const AD_TYPE = {
  SINGLE_IMAGE: {
    value: 1, // 单图
    i18n: 'module_ad_type_single_image', // 文案翻译
    icon: require('src/assets/images/common-image.svg'), // 图标
    desc: 'module_ad_type_single_image_desc', // 描述,
    aliasType: 'image',
  },
  SINGLE_VIDEO: {
    value: 2, // 单视频
    i18n: 'module_ad_type_single_video',
    icon: require('src/assets/images/common-video.svg'),
    desc: 'module_ad_type_single_video_desc',
    aliasType: 'video',
  },
  CATALOGUE_IMAGE: {
    value: 3, // 商品目录图片
    i18n: 'module_ad_type_catalogue_image',
    icon: require('src/assets/images/common-image.svg'),
    desc: '',
    aliasType: 'dpaImage',
  },
  CATALOGUE_VIDEO: {
    value: 4, // 商品目录视频
    i18n: 'module_ad_type_catalogue_video',
    icon: require('src/assets/images/common-video.svg'),
    desc: '',
    aliasType: 'dpaVideo',
  },
  CAROUSEL_IMAGE: {
    value: 5,
    i18n: 'module_ad_type_carousel_image',
    icon: require('src/assets/images/common-image.svg'),
    desc: 'module_ad_type_carousel_image_desc',
    aliasType: 'carouselImage',
  },
  REAL_TIME_LIVE: {
    value: 6, // 实时直播
  },
};

export const CARD_ADDITIONAL_CREATIVE_TYPE = {
  CUSTOMIZED: {
    value: 0, // 自定义
    i18n: 'module_card_additional_creative_customized', // 文案翻译
    iconClass: 'vi-icon2-adjustment', // 图标
    desc: '', // 描述,
    name: 'CUSTOMIZED',
  },
  EXISTING_COMBINATION: {
    value: 1, // collection ads
    i18n: 'module_card_additional_creative_existing',
    iconClass: 'vi-icon2-pingtu',
    desc: '',
    name: 'EXISTING_COMBINATION',
    teaData: {
      'data-tea-style': 'old',
      'data-tea-creative-type': 'collection_ads_single_video',
      'data-tea-expose': 'collection_ads_type_selector_expose_old',
    },
  },
};

// card 的类型
export const ADDITIONAL_CREATIVE_ATTACHMENT_EXPERIENCE_TYPES = {
  IMAGE_CARD: 'imageCard', // 附加创意都适用这个key
  INSTANT_PAGE: 'instantPage',
  ENGAGEMENT: 'engagement',
};

export const ADDITIONAL_CREATIVE_IMAGE_CARD_TEMPLATE_TYPES = {
  GAME_GIFT_CARD: {
    img: require('src/assets/images/additional-creative-game-gift-card-option-preview-img.png'),
    label: 'module_game_gift_card',
    introduce: 'module_game_gift_card_introduce',
    value: 2,
    name: 'GAME_GIFT_CARD',
  },
  CUSTOMIZED_IMAGE: {
    img: require('src/assets/images/additional-creative-customized-image-card-option-preview-img.png'),
    label: 'module_customized_image_card',
    introduce: 'module_customized_image_card_introduce',
    value: 1,
    name: 'CUSTOMIZED_IMAGE',
  },
};
// todo 确定福袋和instant的联动
export const CUSTOM_INSTANT_PAGE_SUPPORT_CARD_TYPES = [
  ADDITIONAL_CREATIVE_IMAGE_CARD_TEMPLATE_TYPES.CUSTOMIZED_IMAGE.value,
];
export const GET_SPECIAL_ADDITIONAL_CREATIVE_INSTANT_PAGE_TEMPLATE_TYPES = () => (
  {
    APP_PROFILE_INSTANT_PAGE: {
      template_id: 1, // 模版 id
      editor_data: 'xxx', // 编辑器数据, list 接口返回的为空
      data: 'xxxx', // 模版初始化数据, list 接口返回的为空
      schema_data: 'xxx', // 格式数据, list 接口返回的为空
      title: i18n.t('module_app_profile_instant_page'), // 模版标题-展示给用户的
      description: i18n.t('module_app_profile_instant_page'), // 模版描述
      creation_type: 1, // 1 - 页面， 2 - 卡片， 3 - 卡片&页面
      video_infos: { // 模版视频信息
        card: {
          // eslint-disable-next-line max-len
          video_url: 'https://sf16-sg.tiktokcdn.com/obj/eden-sg/lm_zkh_rvarpa/ljhwZthlaukjlkulzlp/ads_manager_creation/app-profile-instant-page-with-demo.mp4',
          video_cover_url: require('src/assets/images/app-profile-video-poster.png'),
        },
        page: {
          // eslint-disable-next-line max-len
          video_url: 'https://sf16-sg.tiktokcdn.com/obj/eden-sg/lm_zkh_rvarpa/ljhwZthlaukjlkulzlp/ads_manager_creation/app-profile-instant-page-demo.mp4',
          video_cover_url: require('src/assets/images/app-profile-video-poster.png'),
        },
      },
      thumbnail: require('src/assets/images/app-profile-page-instant-page-demo.png'), // 截图
      business_type: 4,
      template_name: 'interimDownload',
      value: 4,
      name: 'APP_PROFILE_INSTANT_PAGE',
      // App Profile 类型的instant page 不支持任何卡片
      supportCardTypes: [],
    },
  }
);

const getCreativeTypeMap = () => {
  const map = {};
  // {1: 'image'}
  Object.values(AD_TYPE).forEach(({ value, aliasType }) => {
    map[value] = aliasType;
  });
  return map;
};

export const creativeTypeMap = getCreativeTypeMap();
// 这里是抽屉里允许接入的类型，添加一个playable
export const adCreationComponentsAllowedTypes = ['video', 'image', 'carouselImage', 'playable'];

const [CAROUSEL_IMAGE_COUNT_MIN, CAROUSEL_IMAGE_COUNT_MAX] = [2, 10];
export const CAROUSEL_IMAGE_COUNT_LIMIT = [CAROUSEL_IMAGE_COUNT_MIN, CAROUSEL_IMAGE_COUNT_MAX];

export const CAROUSEL_IMAGE_SUPPORT_APP_LIST = [INVENTORY_FLOW.TOPBUZZ];
// 创意工具顶部导航栏配置. 和peacock项目中的配置一一对应
export const VIDEO_CREATIVE_KIT_TABS = {
  VIDEO_GENERATOR: { // 视频制作
    value: 1,
  },
  LANDING_PAGE_VIDEO: { // 落地页视频
    value: 2,
  },
  VIDEO_SOUND_TRACK: { // 视频配乐
    value: 3,
  },
};

// 创意预览处理规则，指需要对预览封面图做的处理
export const CREATIVE_COVER_HANDLER = {
  NONE: -1, // 不处理
  HORIZONTAL_BLACK_1TO1: 1, // 左右加黑边至1：1
  VERTICAL_GOSS_9TO16: 2, // 上下高斯模糊至9:16
  VERTICAL_BLACK_9TO16: 3, // 上下加黑边至9:16
  VERTICAL_EDGE_COLOR_9TO16: 4, // 上下边缘算色至9：16
  HORIZONTAL_GOSS_1TO1: 5, // 左右加高斯模糊至1：1
  HORIZONTAL_EDGE_COLOR_1TO1: 6, // 左右边缘算色至1：1
};

const {
  NONE, HORIZONTAL_BLACK_1TO1, VERTICAL_EDGE_COLOR_9TO16, VERTICAL_BLACK_9TO16, HORIZONTAL_EDGE_COLOR_1TO1,
} = CREATIVE_COVER_HANDLER;

// 创意预览图处理规则映射
export const CREATIVE_PREIVEW_HANDLER_MAP = {
  [INVENTORY_FLOW.TOPBUZZ]: { // 版位
    SQUARE: { // 预览框尺寸 1：1
      VERTICAL: { // 封面图尺寸 9:16
        1: HORIZONTAL_BLACK_1TO1, // 版式1： 左右加黑边至1：1
        2: HORIZONTAL_BLACK_1TO1, // 版式2： 左右加黑边至1：1
      },
      SQUARE: { // 封面图尺寸 1:1
        1: NONE,
        2: NONE,
      },
    },
    HORIZONTAL: { // 预览框尺寸 16:9
      HORIZONTAL: { // 封面图尺寸 16:9
        1: NONE, // 版式1
        2: NONE, // 版式2
      },
    },
  },
  [INVENTORY_FLOW.HELO]: {
    HORIZONTAL: {
      HORIZONTAL: {
        1: NONE,
        2: NONE,
      },
    },
    SQUARE: {
      SQUARE: {
        1: NONE,
        2: NONE,
      },
      VERTICAL: {
        1: HORIZONTAL_EDGE_COLOR_1TO1, // 左右加边缘算色至1：1
        2: HORIZONTAL_EDGE_COLOR_1TO1, // 版式2： 左右加边缘算色至1：1
      },
    },
  },
  [INVENTORY_FLOW.VIGO]: {
    VERTICAL: {
      VERTICAL: {
        1: NONE,
        2: NONE,
      },
      HORIZONTAL: {
        1: VERTICAL_EDGE_COLOR_9TO16,
        2: VERTICAL_EDGE_COLOR_9TO16,
      },
      SQUARE: {
        1: VERTICAL_EDGE_COLOR_9TO16,
        2: VERTICAL_EDGE_COLOR_9TO16,
      },
    },
  },
  [INVENTORY_FLOW.TIKTOK]: {
    VERTICAL: {
      VERTICAL: {
        1: NONE,
      },
      SQUARE: {
        1: VERTICAL_BLACK_9TO16,
      },
      HORIZONTAL: {
        1: VERTICAL_BLACK_9TO16,
      },
    },
  },
  [INVENTORY_FLOW.TIKTOKADNETWORK]: {
    HORIZONTAL: {
      HORIZONTAL: {
        1: NONE,
      },
    },
    SQUARE: {
      SQUARE: {
        1: NONE,
      },
    },
    VERTICAL: {
      VERTICAL: {
        1: NONE,
      },
      SQUARE: {
        1: VERTICAL_BLACK_9TO16,
      },
      HORIZONTAL: {
        1: VERTICAL_BLACK_9TO16,
      },
    },
  },
};
// 试玩素材方向映射
export const PLAYABLE_ORIENTATION = {
  BOTH: { // 横竖版均可
    key: 'library_playable_direction_both',
    value: 0,
  },
  PORTRAIT: { // 竖版
    key: 'library_playable_direction_portrait',
    value: 1,
  },
  LANDSCAPE: { // 横版
    key: 'library_playable_direction_landscape',
    value: 2,
  },
};

export const PLAYABLE_ORIENTATION_REVERSE_MAP = getReverseMap(PLAYABLE_ORIENTATION);

// 试玩素材审核状态
export const PLAYABLE_AUDIT_STATUS = {
  VALIDATING: {
    key: 'library_playable_validating',
    value: 0,
    color: '$--color-group7-5',
  },
  VALIDATE_FAIL: {
    key: 'library_playable_validate_fail',
    value: 1,
    color: '#F45858',
  },
  APPROVING: {
    key: 'library_playable_audit_approving',
    value: 2,
    color: '$--color-group7-5',
  },
  FAILED: {
    key: 'library_playable_audit_failed',
    value: 3,
    color: '#F45858',
  },
  APPROVED: {
    key: 'library_playable_audit_approved',
    value: 4,
    color: '#06D6DB',
  },
};

export const PLAYABLE_AUDIT_STATUS_REVERSE_MAP = getReverseMap(PLAYABLE_AUDIT_STATUS);

/**
 * 与负责试玩素材校验的后端  刘培洋 约定的错误码
 * 错误码由5位3部分组成,
 * 第1位是阶段，1: 文件检验  2: 浏览器检验
 * 第2、3位是类型
 * 第4、5位是具体错误
 */
export const PLAYABLE_ERROR_CODE = {
  NOT_ZIP: '10101', // 文件格式有误
  BEYOND_SIZE_LIMIT: '10201', // 文件大小有误
  NO_ENTRY_HTML: '10301', // 未找到主html文件
  NO_CONFIG_FILE: '10401', // 未找到config文件
  WRONG_CONFIG_FORMAT: '10402', // config文件格式有误
  NO_ORIENTATION_CONFIG: '10501', // 未找到试玩广告播放方向字段
  WRONG_ORIENTATION_VALUE: '10502', // 试玩广告播放方向取值有误
  NO_SDK: '20101', // JS-SDK接入方式
  NOT_EXECUTE_SDK: '20102', // JS-SDK调用方式
  FORBID_MRAID: '20201', // 禁止mraid.js脚本
  FORBID_EXTERNAL_RESOURCE: '20301', // 禁止外部动态素材加载
  FORBID_REQUEST: '20302', // 禁止http请求
  UNKNOWN_ERROR: '90001', // 未知错误
  NO_LANG: '10503', // 未找到试玩广告语言适配字段
  ERROR_LANG: '10504', // 试玩广告语言适配取值有误
};

const {
  NOT_ZIP,
  BEYOND_SIZE_LIMIT,
  NO_ENTRY_HTML,
  NO_CONFIG_FILE,
  WRONG_CONFIG_FORMAT,
  NO_ORIENTATION_CONFIG,
  WRONG_ORIENTATION_VALUE,
  NO_SDK,
  NOT_EXECUTE_SDK,
  FORBID_MRAID,
  FORBID_EXTERNAL_RESOURCE,
  FORBID_REQUEST,
  NO_LANG,
  ERROR_LANG,
} = PLAYABLE_ERROR_CODE;

// 试玩素材要求
export const PLAYABLE_REQUIREMENTS = {
  FORMAT_SIZE: {
    id: 1,
    text: 'library_playable_recommendation_format_size',
    errorCodes: [NOT_ZIP, BEYOND_SIZE_LIMIT], // 可能多个错误码对应一个页面提示
  },
  SDK: {
    id: 2,
    text: 'library_playable_recommendation_sdk',
    errorCodes: [NO_SDK, NOT_EXECUTE_SDK],
  },
  HTML: {
    id: 3,
    text: 'library_playable_recommendation_html',
    errorCodes: [NO_ENTRY_HTML],
  },
  DIRECTION: {
    id: 4,
    text: 'library_playable_recommendation_direction',
    errorCodes: [NO_CONFIG_FILE, WRONG_CONFIG_FORMAT, NO_ORIENTATION_CONFIG, WRONG_ORIENTATION_VALUE],
  },
  MARID: {
    id: 5,
    text: 'library_playable_recommendation_marid',
    errorCodes: [FORBID_MRAID],
  },
  DYNAMIC_MATERIAL: {
    id: 6,
    text: 'library_playable_recommendation_dynamic_material',
    errorCodes: [FORBID_EXTERNAL_RESOURCE],
  },
  REDIRECTION: {
    id: 7,
    text: 'library_playable_recommendation_redirection',
    errorCodes: [],
  },
  HTTP_REQUEST: {
    id: 8,
    text: 'library_playable_recommendation_http_request',
    errorCodes: [FORBID_REQUEST],
  },
  LANGUAGE_EXIST: {
    id: 9,
    text: 'library_playable_recommendation_language_exist',
    errorCodes: [NO_LANG],
  },
  LANGUAGE_MATCH: {
    id: 10,
    text: 'library_playable_recommendation_language_match',
    errorCodes: [ERROR_LANG],
  },
};

// 试玩上传错误枚举
export const PLAYABLE_UPLOAD_ERROR_MAP = {
  TIMEOUT: {
    id: 0,
    key: 'library_playable_error_timeout',
    icon: 'vi-icon-ex-circle-warn',
    color: '#F8AD14',
  },
  NETWORK: {
    id: 1,
    key: 'library_playable_error_network',
    icon: 'vi-icon-ex-circle-warn',
    color: '#F8AD14',
  },
  UNKNOWN: {
    id: 2,
    key: 'library_playable_error_unknown',
    icon: 'vi-icon-ex-circle-fail',
    color: '#F45858',
  },
  FAIL: {
    id: 3,
    key: 'library_playable_error_failed',
    icon: 'vi-icon-ex-circle-fail',
    color: '#F45858',
  },
};

export const PLAYABLE_UPLOAD_ERROR_REVERSE_MAP = getReverseMap(PLAYABLE_UPLOAD_ERROR_MAP, 'id');

export const DPA_WORD_PATTERN_LEFT = '['; // DPA动态词包在广告文案中的模式, 只支持单个字符
export const DPA_WORD_PATTERN_RIGHT = ']'; // DPA动态词包在广告文案中的模式, 只支持单个字符

// 程序化创意的tab
export const PROCEDURAL_AD_TABS = {
  VIDEO: {
    name: 'video',
    value: 2,
    key: 'procedural-material-type-video',
  },
  IMAGE: {
    name: 'image',
    value: 1,
    key: 'procedural-material-type-image',
  },
};

export const creativeSelectOptions = [
  {
    icon: 'creative-template',
    name: 'module_template_name',
    label: 'creativeTemplate',
    subInfo: 'module_template_info',
  },
  {
    icon: 'creative-microVideo',
    name: 'module_micro_video_name',
    label: 'creativeMicrovideo',
    subInfo: 'module_micro_video_info',
  },
];
export const creativeSelect = {
  template: {
    icon: 'creative-template',
    name: 'module_template_name',
    label: 'creativeTemplate',
    subInfo: 'module_template_info',
  },
  microVideo: {
    icon: 'creative-microVideo',
    name: 'module_micro_video_name',
    label: 'creativeMicrovideo',
    subInfo: 'module_micro_video_info',
  },
};

// 原生视频授权审核状态
export const NATIVE_AUDIT_STATUS = {
  APPLYING: {
    key: 'module_library_native_auth_approving', // 申请中
    value: 1,
    color: '$--color-group7-5',
  },
  AUTHORIZED: {
    key: 'module_library_native_auth_success', // 已授权
    value: 2,
    color: '#06D6DB',
  },
  EXPIRED: {
    key: 'module_library_native_auth_expired', // 授权过期
    value: 0,
    color: '#F45858',
  },
  NORESPONSE: {
    key: 'module_library_native_auth_no_response', // 授权未响应
    value: 3,
    color: '#F45858',
  },
  REJECTED: {
    key: 'module_library_native_auth_failed', // 授权拒绝
    value: 4,
    color: '#F45858',
  },
  CANCEL: {
    key: 'module_library_native_auth_cancle', // 授权取消
    value: 5,
    color: '#F45858',
  },
};

export const NATIVE_AUDIT_STATUS_REVERSE_MAP = getReverseMap(NATIVE_AUDIT_STATUS);

export const IES_ITEM_SOURCE_TYPE = {
  AD_SITE: 0,
  IES: 1,
  NATIVE_VIDEO: 2,
};

// 判断原生广告是否已授权
export const INVENTORY_STATUS_TYPE = {
  UNAUDITED: 0, // 待审核
  CONFIRMED: 1, // 审核通过
  REJECTED: 2, // 审核拒绝
  UNAUTHORIZED: 3, // 未授权
};

export const leadAdsFormStatus = {
  completed: 2,
  draft: 1,
};

export const smartTextToolsForbiddenCountries = [
  'US', // 美国
  'CA', // 加拿大
];

/**
 * 协议类型，前端定义用于判断展示
 */
export const PROTOCOL_TYPE = {
  LEAD_ADS: 'leadAds',
  STOREFRONTS: 'storefront',
};
export const ADVERTISER_SETTING_TYPE = {
  selfServiceActivityHiddenSend: 1, // 自助smb扶持打压
  enVatValidateDetail: 2, // 欧洲税号校验详情
  instantPageProtocol: 3, // 轻落地页条款
  crmConnected: 5, // 链接crm
  iosWebAlert: 8,
};

/**
 * protocol 的纬度
 */
export const SETTING_DIMENSION = {
  AdvertiserOnly: 1, // 广告主纬度
  AdvertiserAndUser: 2, // 广告主和用户纬度
};

/**
 * 编辑器返回参数列表及映射
 * key: 平台参数名称
 * value: 对应的辑器返回的参数名称
 */
export const STOREFRONT_EDITOR_PARAM_MAP = {
  call_to_action: 'CTA',
  page_id: 'id',
  product_platform_id: 'product_platform_id',
  product_set_id: 'product_set_id',
  catalog_language: 'catalog_language',
  dpa_products: 'dpa_products',
  dpa_preview_products: 'dpa_products',
  page_product_configuration: 'product_configuration',
  page_preview_url: 'preview_url',
  page_image_url: 'image_url',
  page_card_format: 'card_format',
};

/**
 * Collection ads 页面的卡片类型
 */
export const COLLECTION_ADS_CARD_FORMAT = {
  gallery: 0, // 商品卡片
  imageCard: 1, // 图片卡片
};

/**
 * 创意类型
 */
export const CREATIVE_TYPE = {
  DPA_TPL: 100,
  DPA_CREATIVE: 101,
  LYNX_PDP: 102,
  LYNX_PLP: 103,
  SHOP_PDP: 104,
  SHOP_PLP: 110,
  SHOP_LIVE_VIDEO: 108,
  SHOP_LIVE_REAL_TIME: 109,
};
/*
  adgroup披露的content_type枚举
*/
export const CONTENT_TYPE = {
  SHOP_LIVE_VIDEO: 1,
  SHOP_LIVE_REAL_TIME: 311,
};
// tiktok预览不同版位的名称
export const TIKTOK_PREVIEW_NAME = {
  TIKTOK: 'tiktok',
  SEARCHADS: 'search_ads',
};
// tiktokSearchAds的开关值
export const TIKTOK_SEARCH_ADS_SWITCH = {
  DEFAULT: -1,
  OPEN: 3,
  CLOSE: 0,
};
// searchAds附带的参数，目前后端不用这个，先带上，防止后面使用到
export const TIKTOK_INFOW = 11233531;


// pangle预览不同版位名称
export const PANGLE_PREVIEW_NAME = {
  INTERSTITIAL: 'interstitial',
  REWARDED: 'rewarded',
  NATIVE: 'native',
  BANNER: 'banner',
  SMALL_VIDEO_BANNER: 'small_video_banner',
  NORMAL_BANNER: 'normal_banner',
  THUMBNAIL_BANNER: 'thumbnail_banner',
  ICONS_ONLY_BANNER: 'icons_only_banner',
  NORMAL_NATIVE: 'normal_native',
  VIDEO_THUMBNAIL_NATIVE: 'video_thumbnail_native',
};
// Pangle素材类型为video的预览版位配置
export const PANGLE_VIDEO_AD_VIEWER_LIST = [
  {
    label: '',
    key: '1',
    options: [
      {
        flow: INVENTORY_FLOW.TIKTOKADNETWORK,
        label: 'module_library_interstitial',
        value: PANGLE_PREVIEW_NAME.INTERSTITIAL,
        num: 0,
        position: 0,
        hasEndcard: true,
        comp: 'pangle-ad-preview-interstitial',
        support: [AD_TYPE.SINGLE_IMAGE.value, AD_TYPE.SINGLE_VIDEO.value, AD_TYPE.CATALOGUE_VIDEO.value], // 支持单图、单视频
      },
    ],
  },
  {
    label: '',
    key: '2',
    options: [
      {
        flow: INVENTORY_FLOW.TIKTOKADNETWORK,
        label: 'module_library_rewarded',
        value: PANGLE_PREVIEW_NAME.REWARDED,
        num: 0,
        position: 1,
        hasEndcard: true,
        comp: 'pangle-ad-preview-rewarded',
        support: [AD_TYPE.SINGLE_VIDEO.value, AD_TYPE.CATALOGUE_VIDEO.value],
      },
    ],
  },
  {
    label: 'ad_preview_pangle_banner_group_name',
    key: '3',
    options: [{
      flow: INVENTORY_FLOW.TIKTOKADNETWORK,
      label: 'module_library_normal_banner',
      value: PANGLE_PREVIEW_NAME.NORMAL_BANNER,
      num: 0,
      position: 2,
      hasEndcard: false,
      comp: 'pangle-ad-preview-normal-banner',
      support: [AD_TYPE.SINGLE_IMAGE.value, AD_TYPE.SINGLE_VIDEO.value],
    }, {
      flow: INVENTORY_FLOW.TIKTOKADNETWORK,
      label: 'module_library_video_thumbnail_banner',
      value: PANGLE_PREVIEW_NAME.NORMAL_BANNER,
      num: 0,
      position: 3,
      hasEndcard: false,
      comp: 'pangle-ad-preview-video-thumbnail-banner',
      support: [AD_TYPE.SINGLE_IMAGE.value, AD_TYPE.SINGLE_VIDEO.value],
    }, {
      flow: INVENTORY_FLOW.TIKTOKADNETWORK,
      label: 'module_library_small_video_banner',
      value: PANGLE_PREVIEW_NAME.SMALL_VIDEO_BANNER,
      num: 0,
      position: 4,
      hasEndcard: false,
      comp: 'pangle-ad-preview-small-video-banner',
      support: [AD_TYPE.SINGLE_IMAGE.value, AD_TYPE.SINGLE_VIDEO.value],
    }, {
      flow: INVENTORY_FLOW.TIKTOKADNETWORK,
      label: 'module_library_icons_only_banner',
      value: PANGLE_PREVIEW_NAME.ICONS_ONLY_BANNER,
      num: 0,
      position: 5,
      hasEndcard: false,
      comp: 'pangle-ad-preview-icons-only-banner',
      support: [AD_TYPE.SINGLE_IMAGE.value, AD_TYPE.SINGLE_VIDEO.value],
    }],
  },
  {
    label: 'ad_preview_pangle_native_group_name',
    key: '4',
    options: [{
      flow: INVENTORY_FLOW.TIKTOKADNETWORK,
      label: 'module_library_normal_native',
      value: PANGLE_PREVIEW_NAME.NORMAL_NATIVE,
      num: 0,
      position: 6,
      hasEndcard: false,
      comp: 'pangle-ad-preview-normal-native',
      support: [AD_TYPE.SINGLE_IMAGE.value, AD_TYPE.SINGLE_VIDEO.value],
    }, {
      flow: INVENTORY_FLOW.TIKTOKADNETWORK,
      label: 'module_library_video_thumbnail_native',
      value: PANGLE_PREVIEW_NAME.VIDEO_THUMBNAIL_NATIVE,
      num: 0,
      position: 7,
      hasEndcard: false,
      comp: 'pangle-ad-preview-video-thumbnail-native',
      support: [AD_TYPE.SINGLE_IMAGE.value, AD_TYPE.SINGLE_VIDEO.value],
    }],
  },
];
// pangle素材类型为img的预览版位
export const PANGLE_IMG_AD_VIEWER_LIST = [
  {
    label: '',
    key: '1',
    options: [
      {
        flow: INVENTORY_FLOW.TIKTOKADNETWORK,
        label: 'module_library_interstitial',
        value: PANGLE_PREVIEW_NAME.INTERSTITIAL,
        num: 0,
        position: 0,
        hasEndcard: true,
        comp: 'pangle-ad-preview-interstitial',
        support: [AD_TYPE.SINGLE_IMAGE.value, AD_TYPE.SINGLE_VIDEO.value, AD_TYPE.CATALOGUE_VIDEO.value], // 支持单图、单视频
      },
    ],
  },
  {
    label: '',
    key: '2',
    options: [
      {
        flow: INVENTORY_FLOW.TIKTOKADNETWORK,
        label: 'module_library_rewarded',
        value: PANGLE_PREVIEW_NAME.REWARDED,
        num: 0,
        position: 1,
        hasEndcard: true,
        comp: 'pangle-ad-preview-rewarded',
        support: [AD_TYPE.SINGLE_VIDEO.value, AD_TYPE.CATALOGUE_VIDEO.value],
      },
    ],
  },
  {
    label: 'ad_preview_pangle_banner_group_name',
    key: '3',
    options: [{
      flow: INVENTORY_FLOW.TIKTOKADNETWORK,
      label: 'module_library_normal_banner',
      value: PANGLE_PREVIEW_NAME.NORMAL_BANNER,
      num: 0,
      position: 2,
      hasEndcard: false,
      comp: 'pangle-ad-preview-normal-banner',
      support: [AD_TYPE.SINGLE_IMAGE.value, AD_TYPE.SINGLE_VIDEO.value],
    }, {
      flow: INVENTORY_FLOW.TIKTOKADNETWORK,
      label: 'module_library_icons_only_banner',
      value: PANGLE_PREVIEW_NAME.ICONS_ONLY_BANNER,
      num: 0,
      position: 3,
      hasEndcard: false,
      comp: 'pangle-ad-preview-icons-only-banner',
      support: [AD_TYPE.SINGLE_IMAGE.value, AD_TYPE.SINGLE_VIDEO.value],
    }],
  },
  {
    label: 'ad_preview_pangle_native_group_name',
    key: '4',
    options: [{
      flow: INVENTORY_FLOW.TIKTOKADNETWORK,
      label: 'module_library_normal_native',
      value: PANGLE_PREVIEW_NAME.NORMAL_NATIVE,
      num: 0,
      position: 4,
      hasEndcard: false,
      comp: 'pangle-ad-preview-normal-native',
      support: [AD_TYPE.SINGLE_IMAGE.value, AD_TYPE.SINGLE_VIDEO.value],
    }],
  },
];
// 临时处理：在DPA场景下，pangle版位下掉其中两个
export const DPA_PANGLE_VIDEO_AD_VIEWER_LIST = [
  {
    label: '',
    key: '1',
    options: [
      {
        flow: INVENTORY_FLOW.TIKTOKADNETWORK,
        label: 'module_library_interstitial',
        value: PANGLE_PREVIEW_NAME.INTERSTITIAL,
        num: 0,
        position: 0,
        hasEndcard: true,
        comp: 'pangle-ad-preview-interstitial',
        support: [AD_TYPE.SINGLE_IMAGE.value, AD_TYPE.SINGLE_VIDEO.value, AD_TYPE.CATALOGUE_VIDEO.value], // 支持单图、单视频
      },
    ],
  },
  {
    label: '',
    key: '2',
    options: [
      {
        flow: INVENTORY_FLOW.TIKTOKADNETWORK,
        label: 'module_library_rewarded',
        value: PANGLE_PREVIEW_NAME.REWARDED,
        num: 0,
        position: 1,
        hasEndcard: true,
        comp: 'pangle-ad-preview-rewarded',
        support: [AD_TYPE.SINGLE_VIDEO.value, AD_TYPE.CATALOGUE_VIDEO.value],
      },
    ],
  },
  {
    label: 'ad_preview_pangle_banner_group_name',
    key: '3',
    options: [{
      flow: INVENTORY_FLOW.TIKTOKADNETWORK,
      label: 'module_library_normal_banner',
      value: PANGLE_PREVIEW_NAME.NORMAL_BANNER,
      num: 0,
      position: 2,
      hasEndcard: false,
      comp: 'pangle-ad-preview-normal-banner',
      support: [AD_TYPE.SINGLE_IMAGE.value, AD_TYPE.SINGLE_VIDEO.value],
    }, {
      flow: INVENTORY_FLOW.TIKTOKADNETWORK,
      label: 'module_library_small_video_banner',
      value: PANGLE_PREVIEW_NAME.SMALL_VIDEO_BANNER,
      num: 0,
      position: 3,
      hasEndcard: false,
      comp: 'pangle-ad-preview-small-video-banner',
      support: [AD_TYPE.SINGLE_IMAGE.value, AD_TYPE.SINGLE_VIDEO.value],
    }, {
      flow: INVENTORY_FLOW.TIKTOKADNETWORK,
      label: 'module_library_icons_only_banner',
      value: PANGLE_PREVIEW_NAME.ICONS_ONLY_BANNER,
      num: 0,
      position: 4,
      hasEndcard: false,
      comp: 'pangle-ad-preview-icons-only-banner',
      support: [AD_TYPE.SINGLE_IMAGE.value, AD_TYPE.SINGLE_VIDEO.value],
    }],
  },
  {
    label: 'ad_preview_pangle_native_group_name',
    key: '4',
    options: [{
      flow: INVENTORY_FLOW.TIKTOKADNETWORK,
      label: 'module_library_normal_native',
      value: PANGLE_PREVIEW_NAME.NORMAL_NATIVE,
      num: 0,
      position: 5,
      hasEndcard: false,
      comp: 'pangle-ad-preview-normal-native',
      support: [AD_TYPE.SINGLE_IMAGE.value, AD_TYPE.SINGLE_VIDEO.value],
    }],
  },
];

// 此广告版式下的素材类型
export const MATERIALTYPE = {
  IMG: [AD_TYPE.SINGLE_IMAGE.value, AD_TYPE.CATALOGUE_IMAGE.value, AD_TYPE.CAROUSEL_IMAGE.value],
  VIDEO: [AD_TYPE.SINGLE_VIDEO.value, AD_TYPE.CATALOGUE_VIDEO.value],
};

// Pangle Tooltips 映射
export const pangleToolTipsMap = {
  module_library_normal_banner: 'module_library_normal_banner_video_hover',
  module_library_normal_banner_img: 'module_library_normal_banner_img_hover',
  module_library_video_thumbnail_banner: 'module_library_video_thumbnail_banner_video_hover',
  module_library_small_video_banner: 'module_library_small_video_banner_video_hover',
  module_library_icons_only_banner: 'module_library_icons_only_banner_video_hover',
  module_library_icons_only_banner_img: 'module_library_icons_only_banner_img_hover',
  module_library_normal_native: 'module_library_normal_native_video_hover',
  module_library_normal_native_img: 'module_library_normal_native_img_hover',
  module_library_video_thumbnail_native: 'module_library_video_thumbnail_native_video_hover',
};
// 素材预校验初始值
export const initSuggestion = {
  images: [],
  display_name: [],
  videos: [],
};
const [MIN_TITLE_LENGTH, MAX_TITLE_LENGTH] = [1, 100];
export const CREATIVE_TITLE_LENGTH_LIMIT = [MIN_TITLE_LENGTH, MAX_TITLE_LENGTH];
// 非法标题长度I18n key参数
export const invalidTitleLengthI18nParams = {
  // 半角
  halfMinLength: MIN_TITLE_LENGTH,
  halfMaxLength: MAX_TITLE_LENGTH,
  // 全角
  fullMinLength: Math.ceil(MIN_TITLE_LENGTH / 2),
  fullMaxLength: Math.ceil(MAX_TITLE_LENGTH / 2),
};

export const catAssetTypeEnum = {
  // 支持英语的地区
  EN: 1,
  // 不支持英语的地区传值
  NOTEN: 0,
};

const PRECHECK_RESULT_TRACK_EVENT_ENUMS_MAP = {
  VIDEO_DURATION: 1, // 视频时长
  VIDEO_NO_VOICE: 2, // 视频音频静音
  VIDEO_SIZE: 3, // 视频黑边监测
  IMAGE_CONTENT: 4, // 非中国区恶心图片
  TEXT_CONTENT: 5, // 文本涉政
  IMAGE_LOGO: 6, // 非中国区我司 logo
  MOSAIC: 7, // 马赛克 —— 视频 & 图片
  VIDEO_LOGO: 8, // 视频我司LOGO
  URL_FAIL: 9, // URL校验不通过
  INSUIT_AND_EXAGGERATION: 10, // 视频或者图片或者ad_text中存在侮辱性词包或者夸张描述
  TEXT_INCLUDE_URL: 11, // text中包含文本
  VIDEO_OR_IMG_INCLUDE_SHOCKING_ELEMENT: 12, // 视频或者图片中包含恶心元素
};
const PRECHECK_RESULT_CODE_MAP = {
  VIDEO_DURATION: '21000060',
  VIDEO_SIZE: '21700041',
  VIDEO_NO_VOICE: '21900016',
  IMAGE_CONTENT: '15011',
  IMAGE_LOGO: '20100027',
  MOSAIC: '21500006',
  TEXT_CONTENT_1: '21000059',
  TEXT_CONTENT_2: '21000058',
  TEXT_CONTENT_3: '21000057',
  VIDEO_LOGO: '20100172',
  URL_FAIL: '20700059',
  INSUIT_1: '20200256', // 视频或者图片或者ad_text有侮辱性质的词包
  INSUIT_2: '20100275', // 视频或者图片中有侮辱性的手势
  EXAGGERATION: '21200018', // 视频或者图片或者ad_text存在夸张描述
  TEXT_INCLUDE_URL: '21200046', // text中包含URL
  VIDEO_OR_IMG_INCLUDE_SHOCKING_ELEMENT: '20100520', // 视频或者图片中包含恶心元素
};
// 视频编辑器能修复问题的code集合
export const precheckCanFixCodeList = [
  PRECHECK_RESULT_CODE_MAP.VIDEO_NO_VOICE,
  PRECHECK_RESULT_CODE_MAP.VIDEO_DURATION,
  PRECHECK_RESULT_CODE_MAP.EXAGGERATION,
  PRECHECK_RESULT_CODE_MAP.INSUIT_2,
  PRECHECK_RESULT_CODE_MAP.VIDEO_LOGO,
  PRECHECK_RESULT_CODE_MAP.MOSAIC,
  PRECHECK_RESULT_CODE_MAP.VIDEO_SIZE,
];
// 用户上传的时候，就能修复问题的问题的code集合
export const uploadVideoFixProblemCodeList = [
  PRECHECK_RESULT_CODE_MAP.VIDEO_NO_VOICE,
  PRECHECK_RESULT_CODE_MAP.VIDEO_DURATION,
];
// 预校验问题对应的枚举，主要传给后端使用
export const PRECHECKPROBLEMNUMBER = {
  VIDEO_VOICE: 1,
  VIDEO_DURATION: 2,
};
// 预校验问题对应的枚举，主要传给后端使用
export const uploadVideoProblemMapNumber = {
  [PRECHECK_RESULT_CODE_MAP.VIDEO_NO_VOICE]: PRECHECKPROBLEMNUMBER.VIDEO_VOICE,
  [PRECHECK_RESULT_CODE_MAP.VIDEO_DURATION]: PRECHECKPROBLEMNUMBER.VIDEO_DURATION,
};
// 视频校验min时长和max时长
export const MIN_DURATION = 4.5;
export const MAX_DURATION = 60.5;
// 修复问题后给出的List提示
export const fixProblemTipsList = [
  {
    key: PRECHECK_RESULT_CODE_MAP.VIDEO_NO_VOICE,
    title: 'module_upload_video_fixed_problem_Music_title',
    content: 'material_no_audio',
    eventTrackName: 'Music',
  }, {
    key: PRECHECK_RESULT_CODE_MAP.VIDEO_DURATION,
    title: 'module_upload_video_fixed_problem_duration_title',
    content: 'material_duration',
    eventTrackName: 'Duration',
  },
];
export const uploadEventTrackScene = {
  create: 1, // 创编
  campaignList: 4, // campaignList上传
};
// 修复问题的触发场景
export const CALLVIDEOEDITSCENE = {
  CREATE: 'preCheck', // 创编
  REJECT: 'audit', // 拒审页
};

// 被拒审后，通过视频编辑器能修复的问题的code集合
export const rejectAdCanFixByVideoEditCodeList = [
  100090, // 因为夸张问题被拒审
  100098, // 因为侮辱性问题被拒审
  100076, // 因为视频含有TikTok logo被拒审
  100073, // 因为视频含有马赛克被拒审
];


// 允许自动生成创意名称的创意类型
export const AutoGenerateCreativeNameUseableAdTypes = [
  AD_TYPE.SINGLE_IMAGE.value,
  AD_TYPE.SINGLE_VIDEO.value,
  AD_TYPE.CAROUSEL_IMAGE.value,
];

// TT必杀支持的objective
export const tiktokNotSupportImgObjTypes = [
  campaignObjectiveValue.Traffic,
  campaignObjectiveValue.AppInstall,
  campaignObjectiveValue.Conversion,
  campaignObjectiveValue.Reach,
];

// 允许自动生成创意名称的ObjectiveType
export const autoGenerateCreativeNameUseableObjTypes = [
  campaignObjectiveValue.Reach,
  campaignObjectiveValue.Traffic,
  campaignObjectiveValue.Conversion,
  campaignObjectiveValue.AppInstall,
  campaignObjectiveValue.VideoView,
  campaignObjectiveValue.RF,
  campaignObjectiveValue.LeadAds,
  campaignObjectiveValue.Engagement,
  campaignObjectiveValue.RF_VV,
  campaignObjectiveValue.RF_TRAFFIC,
  campaignObjectiveValue.RF_ENGAGEMENT,
  campaignObjectiveValue.RF_APPINSTALL,
];
// 视频来源
export const videoSource = {
  COMPUTER: 'computer',
  LIBRARY: 'library',
  TOOL: 'tool',
};
export const PRECHECK_RESULT_TYPE_MAP = {
  [PRECHECK_RESULT_CODE_MAP.VIDEO_DURATION]: PRECHECK_RESULT_TRACK_EVENT_ENUMS_MAP.VIDEO_DURATION, // 视频时长
  [PRECHECK_RESULT_CODE_MAP.VIDEO_SIZE]: PRECHECK_RESULT_TRACK_EVENT_ENUMS_MAP.VIDEO_SIZE, // 视频黑边监测
  [PRECHECK_RESULT_CODE_MAP.VIDEO_NO_VOICE]: PRECHECK_RESULT_TRACK_EVENT_ENUMS_MAP.VIDEO_NO_VOICE, // 视频音频静音
  [PRECHECK_RESULT_CODE_MAP.IMAGE_CONTENT]: PRECHECK_RESULT_TRACK_EVENT_ENUMS_MAP.IMAGE_CONTENT, // 非中国区恶心图片
  [PRECHECK_RESULT_CODE_MAP.IMAGE_LOGO]: PRECHECK_RESULT_TRACK_EVENT_ENUMS_MAP.IMAGE_LOGO, // 非中国区我司 logo
  [PRECHECK_RESULT_CODE_MAP.MOSAIC]: PRECHECK_RESULT_TRACK_EVENT_ENUMS_MAP.MOSAIC, // 马赛克 —— 视频 & 图片
  [PRECHECK_RESULT_CODE_MAP.TEXT_CONTENT_1]: PRECHECK_RESULT_TRACK_EVENT_ENUMS_MAP.TEXT_CONTENT, // 文本涉政
  [PRECHECK_RESULT_CODE_MAP.TEXT_CONTENT_2]: PRECHECK_RESULT_TRACK_EVENT_ENUMS_MAP.TEXT_CONTENT, // 文本涉政
  [PRECHECK_RESULT_CODE_MAP.TEXT_CONTENT_3]: PRECHECK_RESULT_TRACK_EVENT_ENUMS_MAP.TEXT_CONTENT, // 文本涉政
  [PRECHECK_RESULT_CODE_MAP.VIDEO_LOGO]: PRECHECK_RESULT_TRACK_EVENT_ENUMS_MAP.VIDEO_LOGO, // 视频我司LOGO
  [PRECHECK_RESULT_CODE_MAP.URL_FAIL]: PRECHECK_RESULT_TRACK_EVENT_ENUMS_MAP.URL_FAIL, // url有问题
  [PRECHECK_RESULT_CODE_MAP.INSUIT_1]: PRECHECK_RESULT_TRACK_EVENT_ENUMS_MAP.INSUIT_AND_EXAGGERATION,
  [PRECHECK_RESULT_CODE_MAP.INSUIT_2]: PRECHECK_RESULT_TRACK_EVENT_ENUMS_MAP.INSUIT_AND_EXAGGERATION,
  [PRECHECK_RESULT_CODE_MAP.EXAGGERATION]: PRECHECK_RESULT_TRACK_EVENT_ENUMS_MAP.INSUIT_AND_EXAGGERATION,
  [PRECHECK_RESULT_CODE_MAP.TEXT_INCLUDE_URL]: PRECHECK_RESULT_TRACK_EVENT_ENUMS_MAP.TEXT_INCLUDE_URL,
  [PRECHECK_RESULT_CODE_MAP.VIDEO_OR_IMG_INCLUDE_SHOCKING_ELEMENT]: PRECHECK_RESULT_TRACK_EVENT_ENUMS_MAP.VIDEO_OR_IMG_INCLUDE_SHOCKING_ELEMENT,
};
// 预校验视频硬伤（禁止使用一键优化）
export const videoCanNotUseOptimizePrecheckTypes = [
  PRECHECK_RESULT_CODE_MAP.MOSAIC,
  PRECHECK_RESULT_CODE_MAP.VIDEO_LOGO,
];

// 判断是否含有非商业挑战赛标识的参数
export const CHALLENGE_TYPE = {
  titles: 'titles',
  urls: 'urls',
};

// 接口返回的标识含义：内容中是否含有非商业挑战赛标识
export const CHALLENGE_AUDIT = {
  NONE: 0, // 监测完成，均为商业挑战赛并且在权限期内
  TITLE_HAS: 1, // 广告文案(title)含有非商业挑战赛或者不在权限期内
  URL_HAS: 2, // 落地页链接(url)含有非商业挑战赛或者不在权限期内
};

// 原生视频音乐是否有版权
export const PROMOTE_MUSIC_VALIDATE_MAP = {
  WITHOUT_SONG_ID: 0, // 原生视频未识别出歌曲
  AUTHORIZATION_MISSING: 1, // 原生视频识别出来的所有歌曲存在部分不具备授权
  WITH_FULL_AUTHORIZATION: 2, // 原生视频识别出来的所有歌曲全部具备授权
};

export const MusicCommercialAuthorizationType = {
  NOT_AUTHORIZED: 0, // 歌曲不具备商业化授权
  AUTHORIZED: 1, // 歌曲具备商业化授权
};

// 原生视频的跟拍/合拍功能的开启状态
export const PROMOTE_MUSIC_ABILITY = {
  TURN_ON: 0, // 打开
  TURN_OFF: 2, // 关闭
};

// 附加创意编辑器 business_type 枚举
export const ADDITIONAL_CREATIVE_EDITOR_BUSINESS_TYPE_ENUMS = {
  LEAD_ADS: 1,
  PLP: 2,
  PDP: 3,
  APP_PROFILE_INSTANT_PAGE: 4,
  GAME_H52LYNX: 5,
  INSTANT_PAGE: 6,
  GAME_GIFT_CARD: 7,
};

// 附加创意编辑器 template_name 枚举
export const ADDITIONAL_CREATIVE_EDITOR_TEMPLATE_NAMES = {
  GAME_GIFT_CARD: 'giftCodeCard',
  CUSTOM_IMAGE_CARD_AND_INSTANT_PAGE: 'imageCardPage',
  INSTANT_PAGE_ONLY: 'instantPage',
  APP_PROFILE_INSTANT_PAGE: 'interimDownload',
};

export const videoInfoExpectRule = {
  duration: val => ['string', 'number'].includes(typeof val) && Number(val) > 0,
  bitrate: val => typeof val === 'number' && val > 0,
  size: val => typeof val === 'number' && val > 0,
  height: val => typeof val === 'number' && val > 0,
  width: val => typeof val === 'number' && val > 0,
};

export const getBusinessCreativeCenterLink = (currentLang) => {
  const link = '/business/creativecenter/';
  // creativeCenter 站只支持中日英
  const creativeCenterSupportLangList = ['en', 'ja', 'zh'];
  const lang = creativeCenterSupportLangList.includes(currentLang)
    ? currentLang
    : 'en';
  return `${link}${lang}`;
};

export const fileTypeMap = {
  imageTypes: ['image/png', 'image/jpeg', 'image/jpg'],
  videoTypes: [
    'video/mp4',
    'video/quicktime', // mov
    'video/mpeg',
    'video/3gpp',
    'video/avi',
  ],
  gifTypes: ['image/gif'],
};

export const VIDEO_ASYNC_RENDER_FILL_ACTION_TYPE = {
  ADD_NEW_CREATIVE: 'ADD_NEW_CREATIVE',
  CHANGE_CREATIVE: 'CHANGE_CREATIVE',
};

// 渲染中的状态
export const VIDEO_ASYNC_RENDER_RENDERING_STATUS = {
  RENDERING: 0, // 渲染中 - 创意侧
  SUBMITTED: 1, // 已上送指定引擎 等待渲染结果
  CANCELLED: 5, // 被上游主动撤销
  WAITING_FOR_DEPENDENCY: 6, // 依赖的任务尚为完成 无法开始
  PAUSED: 7, // 等待上游触发继续渲染
  RESUMED: 8, // 被上游触发继续渲染流程
};
// 渲染出错的状态
export const VIDEO_ASYNC_RENDER_ERROR_STATUS = {
  RENDER_ERROR: 3, // 渲染失败 - 创意侧
  TIMEOUT: 4, // 渲染执行超时, 无渲染结果
};
// 所有状态
export const VIDEO_ASYNC_RENDER_STATUS = {
  RENDER_DONE_NOT_CREATED: 2, // 刚渲染完毕未落库 中间状态 - 创意侧
  ...VIDEO_ASYNC_RENDER_RENDERING_STATUS,
  ...VIDEO_ASYNC_RENDER_ERROR_STATUS,
  RENDER_DONE_AND_CREATED: 1000, // 渲染并落库成功 - 平台侧定义
  RENDER_DONE_NAME_ERROR: 1001, // 落库因重名而失败 - 平台侧定义
  RENDER_DONE_CREATED_FAILED: 1002, // 落库失败 - 平台侧定义
};

export const VIDEO_RENDER_OPTIONS = {
  POLLING_DELAY: 3 * 1000, // 轮询间隔
  SINGLE_VIDEO_RENDER_TRY_COUNT: 3, // 单个视频重试次数上限
};

export const CREATIVE_TOOL_VIDEO_RENDER_MODE = {
  RENDER_BY_TOOL: 1, // 工具内渲染
  RENDER_BY_PLATFORM: 2, // 平台异步渲染
};


// 站内跳转链接(回流页)类型
export const ReflowType = {
  ITEM: '0', // 视频详情页
  MUSIC: '1', // 音乐聚合页
  STICKER: '2', // 贴纸聚合页
  CHALLENGE: '3', // 挑战聚合页
  USER: '4', // 个人主页
  SHOP: '5', // tiktok shop
};


export const SchemeType = {
  VIDEO: '1', // 视频详情页
  USERPROFILE: '2', // 个人主页
  MUSIC: '3', // 音乐详情页
  STICKER: '4', // 特效聚合页
  CHALLENGE: '5', // 挑战赛页
  STICKER_SHOOTER: '6', // 特效开拍页
  SHOP: '7', // tiktok shop
};

// deeplink在推广目标为安卓的app时，没有全量的国家
export const deeplinkNotAllCountryListCode = [
  1861060, // 日本
  3469034, // 巴西
  357994, // 埃及
];

// 原生推视频是否选择dark post模式
export const DARK_POST_STATUS_MAP = {
  ON: 1, // 打开darkpost开关
  OFF: 2, // 关闭darkpost开关
};

// 原生创意行为类型
export const NATIVE_AD_ACTION_TYPE = {
  PULL_TT_POST: 2, // TikTok Post 拉视频原生创意
  PUSH_VIDEO_TO_TTBA: 3, // TTBA 推视频原生创意
  REAL_TIME_LIVE: 2, // 直投直播间要求item_source是2,作原生处理
};
// 配置下掉模型的校验规则
// 拉视频下掉TikTok logo && 时长的校验
const PULL_VIDEO_IGNORE_CODE_LIST = [
  PRECHECK_RESULT_CODE_MAP.VIDEO_LOGO,
  PRECHECK_RESULT_CODE_MAP.VIDEO_DURATION,
];
// 推视频下掉TikTok logo的校验
const PUSH_VIDEO_IGNORE_CODE_LIST = [
  PRECHECK_RESULT_CODE_MAP.VIDEO_LOGO,
];
// 本次创建广告是否全为拉视频或者推视频
const isAllNativeAdOrTTBAPushVideo = (verifyAdsParams) => {
  const creativeList = _.get(verifyAdsParams, 'creative_info.video_list', []);
  if (creativeList.length <= 0) return 'NOT'; // 并非全是推视频或者是拉视频
  if (creativeList.every(item => item.item_source === NATIVE_AD_ACTION_TYPE.PULL_TT_POST)) return 'ALL_PULL'; // 全为拉视频
  if (creativeList.every(item => item.item_source === NATIVE_AD_ACTION_TYPE.PUSH_VIDEO_TO_TTBA)) return 'ALL_PUSH'; // 全为推视频
  return 'NOT';
};
// 使用index 移除数组中的多项
const withIndexremoveItemsfromArrary = (targetArr, indexList) => {
  for (let i = targetArr.length - 1; i >= 0; i--) {
    if (indexList.includes(i)) {
      targetArr.splice(i, 1);
    }
  }
};
// 过滤预校验中的一些模型
const filterPrechckSomeResult = (precheckRes, type) => {
  let removeCodeList = [];
  const summaryResults = [];
  switch (type) {
    case 'ALL_PULL':
      removeCodeList = PULL_VIDEO_IGNORE_CODE_LIST;
      break;
    case 'ALL_PUSH':
      removeCodeList = PUSH_VIDEO_IGNORE_CODE_LIST;
      break;
    default:
      return [];
  }
  const deepclonePrecheckRes = _.cloneDeep(precheckRes.material_results);
  deepclonePrecheckRes.forEach(AdItem => AdItem.videos.forEach((videoItem) => {
    // 从suggtion和tag_ids中移除相关校验
    const needRemoveCodeList = _.intersection(videoItem.tag_ids, removeCodeList);
    const needRemoveCodeIndexList = needRemoveCodeList.map(removeCode => videoItem.tag_ids.findIndex(code => code === removeCode));
    withIndexremoveItemsfromArrary(videoItem.tag_ids, needRemoveCodeIndexList);
    withIndexremoveItemsfromArrary(videoItem.suggestion, needRemoveCodeIndexList);
    // 在detail中delete掉相关字段
    needRemoveCodeList.forEach((code) => {
      delete videoItem.details[code];
    });
  }));
  // 删除完毕之后重新拿到新的summary_results
  deepclonePrecheckRes.forEach((adItem) => {
    const keyList = Object.keys(adItem);
    keyList.forEach((key) => {
      const itemSuggtion = _.get(adItem, `${key}[0].suggestion`, []);
      if (itemSuggtion.length >= 1) {
        summaryResults.push(...itemSuggtion);
      }
    });
  });
  return {
    material_results: deepclonePrecheckRes,
    summary_results: summaryResults,
  };
};

// 过滤预校验的结果
export const filterPrecheckResult = (precheckRes, verifyAdsParams) => {
  try {
    switch (isAllNativeAdOrTTBAPushVideo(verifyAdsParams)) {
      // 什么都不处理原样返回
      case 'NOT':
        return precheckRes;
      // 针对提交广告的时候全是拉视频，针对video下掉一些检验
      case 'ALL_PULL':
        return filterPrechckSomeResult(precheckRes, 'ALL_PULL');
      // 针对提交广告的时候全是推视频，针对video下掉一些检验
      case 'ALL_PUSH':
        return filterPrechckSomeResult(precheckRes, 'ALL_PUSH');
      default:
        return precheckRes;
    }
  } catch (e) {
    return precheckRes;
  }
};

// 支持TTBA 推视频的Objective
export const SUPPORT_TTBA_PUSH_NATIVE_ADS_OBJECTIVE_TYPES = [
  campaignObjectiveValue.Reach,
  campaignObjectiveValue.Traffic,
  campaignObjectiveValue.VideoView,
  campaignObjectiveValue.AppInstall,
  campaignObjectiveValue.Conversion,
  campaignObjectiveValue.RF,
  campaignObjectiveValue.RF_VV,
  campaignObjectiveValue.Shop,
  campaignObjectiveValue.LeadAds,
  campaignObjectiveValue.Engagement,
];

export const playableAdsUploaderSources = {
  campaign: 'campaign', // 创编
  library: 'library', // 素材库
  campaignLibrary: 'campaign-library', // 创编的素材库抽屉
};

// 试玩广告用户操作类型，用于埋点
export const playableAdsOperationType = {
  change: 'change',
  preview: 'preview',
  delete: 'delete',
};
// 试玩广告用户点击helpCenter的场景，用于埋点
export const playableAdsClickHelpCenterMap = {
  moduleTips: 'module_tips',
  bubbleTips: 'bubble_tips',
  library: 'library',
  emptyLibrary: 'empty_library',
};

// 福袋/手势创意类型
export const ENGAGEMENT_CREATIVE_TYPE = {
  EGG: 57,
  GESTURE: 58,
};

// 免责声明类型
export const DISCLAIMER_TYPES = {
  UN_SET: 0, // 未设置
  TEXT_ONLY: 1, // 仅文字
  TEXT_WITH_LINK: 2, // 文字链
};
export const disclaimerOptions = {
  textOnly: {
    textLengthOptions: {
      // 半角
      halfMinLength: 1,
      halfMaxLength: 90,
      // 全角
      fullMinLength: Math.ceil(1 / 2),
      fullMaxLength: Math.ceil(90 / 2),
    },
  },
  textWithLink: {
    maxCount: 3,
    minCount: 1,
    textLengthOptions: {
      // 半角
      halfMinLength: 1,
      halfMaxLength: 40,
      // 全角
      fullMinLength: Math.ceil(1 / 2),
      fullMaxLength: Math.ceil(40 / 2),
    },
  },
};
export const GET_DISCLAIMER_PROPS_NAME_BY_TYPE = {
  [DISCLAIMER_TYPES.TEXT_ONLY]: 'disclaimer_text.text',
  [DISCLAIMER_TYPES.TEXT_WITH_LINK]: 'disclaimer_clickable_texts',
};
export const SET_DISCLAIMER_PROPS_NAME_BY_TYPE = {
  [DISCLAIMER_TYPES.TEXT_ONLY]: 'disclaimer_text',
  [DISCLAIMER_TYPES.TEXT_WITH_LINK]: 'disclaimer_clickable_texts',
};

// 一个计划下的创意数量的限制
export const ADS_MAX_NUM = {
  DEFAULT: 20,
  SHOP_ADS_LIVE_VIDEO: 10,
  SHOP_ADS_LIVE_REAL_TIME: 1,
  SPLIT_TEST: 1,
};

export const PROMOTION_WEBSITE_TYPE = {
  ON_SITE: 1,
  OFF_SITE: 0,
};

/** 展示音乐安全协议的地区 */
export const SHOW_MUSIC_PROTOCOL_COUNTRY_LIST = [
  'US', 'CA', 'MX', 'PE', 'CL', 'CO', 'AR', 'BR',
];

export const ATTACHMENT_CREATIVE_TYPES_ENUM = {
  GIFT_CODE_CARD: 55, // 游戏礼包码卡片
  DISPLAY_CARD: 56, // 自定义图片卡
  LUCKY_BAG_V2: 57, // 福袋
  GESTURE: 58, // 互动手势
  VOTING_STICKER: 59, // 投票贴纸
  GIFT_CODE_STICKER: 60, // 礼包码贴纸
  COUNTDOWN_STICKER: 61, // 倒计时贴纸
};

export const ATTACHMENT_CTEATIVE_TYPES2_ENABLE_URL = [
  ATTACHMENT_CREATIVE_TYPES_ENUM.LUCKY_BAG_V2,
  ATTACHMENT_CREATIVE_TYPES_ENUM.GESTURE,
  ATTACHMENT_CREATIVE_TYPES_ENUM.VOTING_STICKER,
  ATTACHMENT_CREATIVE_TYPES_ENUM.GIFT_CODE_STICKER,
  ATTACHMENT_CREATIVE_TYPES_ENUM.COUNTDOWN_STICKER,
];

export const ATTACHMENT_ID_TYPE = {
  DISPLAY_CARD: 1,
  GIFT_CODE_CARD: 2,
  GESTURE: 4,
  LUCKY_BAG_V2: 5,
  VOTING_STICKER: 6, // 投票贴纸
  COUNTDOWN_STICKER: 7, // 倒计时贴纸
  GIFT_CODE_STICKER: 8, // 礼包码贴纸
};

// 附加创意类型label
export const ATTACHMENT_ID_TYPE2_LABEL_MAP = {
  [ATTACHMENT_ID_TYPE.GIFT_CODE_CARD]: 'module_attachment_creative_game_gift_card',
  [ATTACHMENT_ID_TYPE.DISPLAY_CARD]: 'module_attachment_creative_display_card',
  [ATTACHMENT_ID_TYPE.LUCKY_BAG_V2]: 'module_additional_creative_engagement_type_egg_label',
  [ATTACHMENT_ID_TYPE.GESTURE]: 'module_additional_creative_engagement_type_gesture_label',
  [ATTACHMENT_ID_TYPE.VOTING_STICKER]: 'module_attachment_creative_voting_sticker',
  [ATTACHMENT_ID_TYPE.GIFT_CODE_STICKER]: 'module_attachment_creative_gift_sticker',
  [ATTACHMENT_ID_TYPE.COUNTDOWN_STICKER]: 'module_attachment_creative_count_down_sticker',
};

// 这些推广系列在选择特定附加创意时，需要打开destination 开关
export const AUTO_OPEN_DESTINATION_STWICH_OBJECTIVE_TYPES = [
  campaignObjectiveValue.RF,
  campaignObjectiveValue.RF_VV,
  campaignObjectiveValue.Reach,
  campaignObjectiveValue.VideoView,
];

export const ADDITIONAL_CREATIVE_ENGAGEMENT_TYPES = {
  IMAGE_CARD: {
    value: 1,
    name: 'image_card',
    label: 'module_additional_creative_engagement_type_card_label',
    img: customizedImageCardPoster,
    desc: '',
  },
  EGG: {
    value: ATTACHMENT_ID_TYPE.LUCKY_BAG_V2,
    name: 'egg',
    label: 'module_additional_creative_engagement_type_egg_label',
    img: eggDemoImg,
    desc: '',
  },
  GESTURE: {
    value: ATTACHMENT_ID_TYPE.GESTURE,
    name: 'gesture',
    label: 'module_additional_creative_engagement_type_gesture_label',
    img: gestureDemoImg,
    desc: '',
  },
};
// 商品锚点状态枚举
export const SHOP_ANCHOR_STATUS = {
  DEFAULT: 0, // 其他原因导致的失效
  CHECK_SUCCESS: 1, // 审核成功
  CHECK_ING: 101, // 审核中
  CHECK_FAIL: 102, // 审核失败
  PRODUCT_TAKEN_DOWN: 201, // 锚点商品下架
  PRODUCT_NO_STOCK: 202, // 锚点商品无库存
};
export const SHOP_ANCHOR_UNAVAILABLE_MAP = {
  [SHOP_ANCHOR_STATUS.DEFAULT]: 'module_craetive_shop_anchor_disabled_warning',
  [SHOP_ANCHOR_STATUS.PRODUCT_NO_STOCK]: 'module_creative_shop_anchor_no_stock',
  [SHOP_ANCHOR_STATUS.PRODUCT_TAKEN_DOWN]: 'module_creative_shop_anchor_taken_down',
  [SHOP_ANCHOR_STATUS.CHECK_ING]: 'module_creative_shop_anchor_checking',
  [SHOP_ANCHOR_STATUS.CHECK_FAIL]: 'module_creative_shop_anchor_check_fail',
};
// 校验shop anchor的有效性 单锚点 && 锚点绑定的商品id === spuid && 锚点状态为可用
export const isShopAnchorValid = (anchors = [], supId = '') => {
  // 单锚点
  const isSingleProductAnchor = Array.isArray(anchors) && anchors.length === 1;
  if (!supId || !isSingleProductAnchor) return false;
  const { id: videoAnchorId, visibility_status: videoAnchorStatus } = anchors[0];
  if (!videoAnchorId || !videoAnchorStatus) return false;
  // 锚点状态有效
  const isVideoAnchorStatusAvailable = videoAnchorStatus === SHOP_ANCHOR_STATUS.CHECK_SUCCESS;
  // 锚点绑定的商品id === spuid
  const isCurSpuIdEqualToAnchorId = supId === videoAnchorId;
  return isVideoAnchorStatusAvailable && isCurSpuIdEqualToAnchorId;
};
// 视频转码状态枚举
export const VIDEO_TRANSCODE_STATUS = {
  TRANSCODE_FAIL: 20, // 转码失败
  TRANSCODE_SUCCESS: 10, // 转码成功
};
/** 素材库视频来源 */
export const MaterialLibraryVideoSource = {
  AD_SITE: 'ad_site', // TTAM
};


// 视频特殊校验，只有一个提示文案，不区分版位
export const specFail = [
  VERIFY_ERROR_CODE.VIDEO.transcodeFail.value,
];
